const options = [
	{
		key: 1,
		text: "En Línea",
		value: "En Línea",
	},
	{
		key: 2,
		text: "No Asigna Chat",
		value: "No Asigna Chat",
	},
	{
		key: 3,
		text: "Almuerzo",
		value: "Almuerzo",
	},
	{
		key: 4,
		text: "Baño",
		value: "Baño",
	},
	{
		key: 5,
		text: "Break",
		value: "Break",
	},
	{
		key: 6,
		text: "Gestión Interna",
		value: "Gestión Interna",
	},
	{
		key: 7,
		text: "En Reunión",
		value: "En Reunión",
	},
];

export default options;
